/**
 * Last-used surface persistence — remembers whether a dual-entitlement user
 * (see ``surfaceAccess`` in ``../access``) last worked in the PRODUCT or the
 * CONSOLE, so the post-login landing (``routes/_authed/index.tsx``) can
 * restore it. Plain localStorage (same durability class as the workspace
 * last-tab store); storage failures degrade to the product default.
 */

export type Surface = "product" | "console";

/** localStorage key — shared contract with the landing redirect. */
export const SURFACE_STORAGE_KEY = "ando.surface";

const DEFAULT_SURFACE: Surface = "product";

/** Read the persisted surface; unknown/absent/broken storage → "product". */
export function getPreferredSurface(): Surface {
  try {
    return window.localStorage.getItem(SURFACE_STORAGE_KEY) === "console"
      ? "console"
      : DEFAULT_SURFACE;
  } catch {
    return DEFAULT_SURFACE;
  }
}

/** Persist the surface the user just switched to. Best-effort. */
export function setPreferredSurface(surface: Surface): void {
  try {
    window.localStorage.setItem(SURFACE_STORAGE_KEY, surface);
  } catch {
    // Storage unavailable (private mode / quota) — landing falls back to
    // the product default, which is always a safe destination.
  }
}
